document.addEventListener( 'alpine:init', () => {
	Alpine.data( 'productTriptychPanel', () => ({
		open: false,

		toggle() {
			this.open = ! this.open;
		},

		close() {
			this.open = false;
		},
	}) );
});
